import { getConfig } from '@klpkonsern/appconfig';

export const byggApiName = 'bygg';
export const byggFavorittApiName = 'favoritt';

export const MineByggAccess = (): boolean =>
    getConfig('WEBAPP_MINE_BYGG_ENABLE', false);
